<div class="primary full-page-height display-flex-lg">
    <!-- <div class="col-md-4">
    </div> -->
    <div class="forgot-dialog">
        <div class="col-md-12">
            <div class="form custom-form">
                <a class="link" [routerLink]="['/login']">Back to Login</a>
                <h6>Forgot your Password?</h6>
                <div class="content">
                    <p>Please enter the email address linked to your account.</p>
                    <p>We will send you an Email:</p>
                </div>
                <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit(resetPasswordForm)">
                    <label>Email Address</label>
                    <span class="form-error-text" *ngIf="emailAddress.touched && emailAddress.value != '' && emailAddress.invalid">Please enter the valid email address</span>
                    <span class="form-error-text" *ngIf="emailAddress.touched && emailAddress.value == ''">Email is required</span>
                    <input type="email" name="email" formControlName="email">

                    <button type="submit" [disabled]="!resetPasswordForm.valid">Continue</button>

                </form>
            </div>
            <!-- <div>
                <a class="link" routerLink="/login">Login</a>
            </div> -->
        </div>
    </div>
</div>